var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPause = function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6.4v15.2H8.4V.4h1.2Z",
    fill: "#42210A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6.4v15.2H8.4V.4h1.2Z",
    fill: "#42210A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6.4H.4V3h1.2V.4ZM.4 15.6h1.2V4.5H.4v11.1Z",
    fill: "#42210A"
  })));
};
export default SvgPause;